/* eslint-disable react/no-unstable-nested-components */
/* this linter is causing false positives in this file because of how the tag
 * replacers are being created. Hopefully the problem will go away when we get
 * away from super old react-intl
 */
import React from "react";

import { FooterText } from "@components/FormFooter/FooterTextComponent";

import { useViewModel } from "@/lib/state/contextHooks";
import { getLocaleSafely } from "@/lib/intl/intl";
import { setViewModel } from "@/lib/VerificationService/ViewModel";
import { type VerificationService } from "@/lib/types/types";

export interface FormFooterProps {
  verificationService?: VerificationService;
  children?: React.ReactNode;
  showShield?: boolean;
}

export const FormFooterComponent = ({ children, showShield = false }: FormFooterProps) => {
  const viewModel = useViewModel();
  const locale = getLocaleSafely(viewModel);
  const privacyPolicyRef = React.useRef<any>({});

  // Store the footer message that the user was shown when the user submitted
  React.useEffect(() => {
    if (!privacyPolicyRef.current) {
      return;
    }
    const privacyPolicyText = privacyPolicyRef.current.textContent;
    const updatedViewModel = { metadata: { submissionOptIn: privacyPolicyText } };
    setViewModel(updatedViewModel);
  }, [privacyPolicyRef, locale]);

  return (
    <div className="sid-footer sid-h-small-text sid-l-space-top-md" role="contentinfo">
      {(showShield || !children) && (
        <div className="sid-footer__shield">
          <img
            alt=""
            src="https://assets-resources.sheerid.com/common/images/2018/icons/shield-check.svg"
          />
        </div>
      )}
      <div>
        <div className="sid-footer__one" ref={privacyPolicyRef}>
          {children || <FooterText />}
        </div>
      </div>
    </div>
  );
};
